export const CLAIM_REASONS = [
  { value: "damaged", label: "Damaged in transit" },
  { value: "lost", label: "Lost" },
  { value: "never_delivered", label: "Never delivered" },
  { value: "lost_after_delivery", label: "Lost after delivery" },
  { value: "no_movement", label: "No tracking movement" },
];

export const CLAIM_STATUS_FLOW = [
  "received",
  "filed_with_carrier",
  "under_review",
  "approved",
  "credit_applied",
];

export const CLAIM_STATUS_META = {
  received: { label: "Claim received", cls: "bg-slate-100 text-slate-700" },
  filed_with_carrier: { label: "Filed with carrier", cls: "bg-blue-100 text-blue-700" },
  under_review: { label: "Under review", cls: "bg-amber-100 text-amber-800" },
  approved: { label: "Approved", cls: "bg-green-100 text-green-700" },
  credit_applied: { label: "Credit applied", cls: "bg-emerald-100 text-emerald-700" },
  denied: { label: "Denied", cls: "bg-red-100 text-red-700" },
};

export const REASON_LABEL = (v) =>
  CLAIM_REASONS.find((r) => r.value === v)?.label || (v || "").replace(/_/g, " ");
